import React, {useState, useEffect} from 'react';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import InfoIcon from '@mui/icons-material/Info';
import {getStatus} from '../../api';
import CircleIcon from '@mui/icons-material/Circle';
import * as Sentry from '@sentry/react';

function Header() {
  const [status, setStatus] = useState('establishing connection');
  const [tickCount, setTickCount] = useState(0);
  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        const result = await getStatus();
        setStatus(result.health);
        Sentry.setTag('server-health', result.health);
      } catch (err) {
        setStatus('weak internet connection detected');
        Sentry.setTag('server-health', 'weak internet connection detected');
      }
      setTickCount(tickCount + 1);
    }, 10000);
    (async ()=>{
      try {
        const result = await getStatus();
        setStatus(result.health);
        Sentry.setTag('server-health', result.health);
      } catch (err) {
        setStatus('weak internet connection detected');
        Sentry.setTag('server-health', 'weak internet connection detected');
      }
    })();
    return () => clearInterval(interval);
  }, [tickCount]);

  return (
    <div style={{marginTop: 10, textAlign: 'center', position: 'sticky', bottom: 0, width: '100% !important', height: '100px !important'}}>
      <Chip
        avatar={status !== 'weak internet connection detected' ? <Avatar alt="Application Status" src={`https://rtevent.crisp.watch/includes/badge/?tick=${tickCount}`} /> : <CircleIcon fontSize="large" style={{color: 'orange'}} />}
        label={'Status: ' + status}
        variant="outlined"
        component="a"
        href="https://rtevent.crisp.watch/en/"
        size="small"
        onClick={()=>{}}
      >
      </Chip>

    </div>
  );
}

export default Header;
